<template>
	<main>
		<section id="urgent-campaign" >
			<campaign-data :data="campaign" :total="totalCampaign" />
			<section class="flex justify-center">
				<vs-button 
				    size="small"
				    v-for="(item, i) in numPage"
				    :key="i"
				    class="rounded-none"
				    :type="item.active ? 'filled' : 'border'"
				    @click.prevent="change(i, item.num)"
				>
					{{item.num}}
				</vs-button>
			</section>
		</section>
	</main>
</template>
<script>
import CampaignData from './components/CampaignData.vue'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('campaign', ['campaign', 'totalCampaign'])
  },
  data () {
    return {
      campaigns: [],
      numPage: [],
      activePage: 1,
      params: {
        ord: 'desc',
        start: 0,
        length: 10
      }
    }
  },
  methods: {
    change (start, activePage) {
      this.params = {
        ord: 'desc',
        start,
        length: 10
      }
      this.activePage = activePage
      this.getCampaign()
    },
    getCampaign () {
      this.$store.dispatch('campaign/getData', this.params)
        .then(() => {
          this.numPage = []
          this.$vs.loading.close()

          if (this.totalCampaign > 0) {
            const totalNum = Math.ceil(this.totalCampaign / this.campaign.length)
            for (let i = 0; i < totalNum; i++) {
              const num = i + 1
              this.numPage.push({
                active: false,
                num
              })	
            }
						
            this.numPage.forEach(item => {
              if (item.num === this.activePage) {
                item.active = true
              } else {
                item.active = false
              }
            })

          }
        })
        .catch(e => {
          this.$vs.loading.close()
          if (e.response) console.error(e.response)
          this.$vs.notify({
            title: 'Oops',
            text: e.response.data.message,
            color: 'warning',
            position: 'top-right'
          })
          return false
        })
    }
  },
  components: {
    CampaignData
  },
  mounted () {
    this.$vs.loading()
    this.getCampaign()
  }
}
</script>